import * as THREE from 'three';

const DEFAULT_CONTROLS_MINDIST = 0.7;
const DEFAULT_CONTROLS_MAXDIST = 7;
const lightTypes = {
        'PointLight': { position: {x:5,y:5,z:5 }  },
        'SpotLight': { penumbra: 0.2, angle: Math.PI/4 },
        'DirectionalLight': { },
        'AmbientLight': { },
        'RectAreaLight': { },
        'HemisphereLight': { }
};

let lightNamesCounter = {};

export function setupCamera() {
	cameraTargetPosition = DEFAULT_CAMERA_POSITION.clone();
	cameraTargetLookAt = DEFAULT_CAMERA_LOOKAT; 
}	

export function setupControls() {
	defaultControlsMinDist = 0.7;
        defaultControlsMaxDist = 7;

}

export function configureControls(controls) {
        controls.minDistance = DEFAULT_CONTROLS_MINDIST;
        controls.maxDistance = DEFAULT_CONTROLS_MAXDIST;
        controls.enable = true;
        controls.enableZoom = false;
	controls.update();
}

export function addLight(scene, type = 'PointLight', options = { position: {x:5,y:5,z:5}}) {
	const defaultOptions = lightTypes[type];
	options = { ...defaultOptions, ...options };
	const light = new THREE[type](options);
	if (!light) return null;
	Object.keys(options).forEach((key) => {
		switch(key) {
			case 'position':
				if (key === 'position' && typeof options.position === 'object') {
					light.position.set(options.position.x, options.position.y, options.position.z);
				}
				break;
			case 'color':
				//console.log(key+' : '+options[key]);
				break;
			default:
				light[key] = options[key];
				break;
		}
	});
	if(light.shadow) {
		light.shadow.mapSize.set(2048,2048);
		light.shadow.bias = -0.01;
	}
	if (!lightNamesCounter[type]) {
		lightNamesCounter[type] = 1;
	} else {
		lightNamesCounter[type]++;
	}
	light.lightName = options.lightName || `${type}-${lightNamesCounter[type] || 1}`;
	if (light.color && light.color.isColor) {
		if(options.color) {
			light.color.setHex(options.color);
		}
		const colorHex = '#' + light.color.getHexString();
	}
	if (light.groundColor && light.groundColor.isColor) {
		if(options.groundColor) {
			light.groundColor.setHex(options.groundColor);
		}
	}
	scene.add(light);
	return light;
}

export function setSpecificShadows(object) {
        object.castShadow = true;
        object.receiveShadow = true;
        object.children.forEach(setSpecificShadows);
}

export function roundNumber(num, decimals) {
        return Math.round(num * Math.pow(10, decimals)) / Math.pow(10, decimals);
}

export function xyz(v) {
        return v.x.toFixed(2)+', '+v.y.toFixed(2)+', '+v.z.toFixed(2);
}

